import { makeRequest } from 'src/utils/graphql';
import {
  QUERY_SEARCH_FILTER_DATA,
  QUERY_TOP_SEARCHED_PRODUCT_CATEGORIES,
  QUERY_TOP_SEARCHED_PRODUCTS,
} from '../queries';
import axios from 'axios';

// import mock from './mock.json';

import { ProductCategoryEntity, ProductEntity } from 'src/modules/products';
import { SearchActions, SearchFilterData, algoliaSearch } from 'src/modules/search';
import { DesignerEntity } from 'src/modules/designers';
import { LocationTypeEntity } from 'src/modules/locationTypes';

const {
  FetchSearchDataBegin,
  FetchSearchDataSuccess,
  FetchSearchDataError,
  FetchSearchSuggestionsDataBegin,
  FetchSearchSuggestionsDataSuccess,
  FetchSearchSuggestionsDataError,
  FetchTopSearchedProductCategoriesBegin,
  FetchTopSearchedProductCategoriesError,
  FetchTopSearchedProductCategoriesSuccess,
  FetchTopSearchedProductsBegin,
  FetchTopSearchedProductsError,
  FetchTopSearchedProductsSuccess,
  FetchSearchFilterDataBegin,
  FetchSearchFilterDataSuccess,
  FetchSearchFilterDataError,
} = SearchActions;

export interface ProductsSearchResponseData {
  results: ProductEntity[];
  count: number;
}

let cancelRequest;
export const fetchSearchSuggestionsData = (term: string, outputChannel) => {
  return async (dispatch) => {
    dispatch(fetchSearchSuggestionsDataBegin());
    // const CancelToken = axios.CancelToken;
    try {
      // Cancel previous request request
      cancelRequest && cancelRequest();
      const response = await algoliaSearch(term, outputChannel);
      // const response = await axios.post(
      //   `${process.env.NEXT_PUBLIC_API_URL}/search`,
      //   {
      //     term,
      //     outputChannel,
      //   },
      //   {
      //     cancelToken: new CancelToken(function executor(c) {
      //       cancelRequest = c;
      //     }),
      //   }
      // );

      dispatch(fetchSearchSuggestionsDataSuccess(response as ProductsSearchResponseData));
    } catch (e) {
      // check if the request was cancelled
      if (axios.isCancel(e)) {
        // console.log('Request cancelled');
      } else {
        console.log(e);
        dispatch(fetchSearchSuggestionsDataError({ message: e.message }));
      }
    }
  };
};

export const fetchSearchSuggestionsDataBegin = () => ({
  type: FetchSearchSuggestionsDataBegin,
});

export const fetchSearchSuggestionsDataSuccess = (responseData: ProductsSearchResponseData) => ({
  type: FetchSearchSuggestionsDataSuccess,
  payload: responseData,
});

export const fetchSearchSuggestionsDataError = (error) => ({
  type: FetchSearchSuggestionsDataError,
  payload: { error },
});

export const fetchSearchData = (
  term: string,
  outputChannel: string,
  filters: SearchFilterData,
  offset: number = 0
) => {
  return async (dispatch) => {
    dispatch(fetchSearchDataBegin(term));

    try {
      // const response = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/search`, {
      //   term,
      //   productCategoryIds: filters.productCategories.map(({ id }) => id),
      //   designerIds: filters.designers.map(({ id }) => id),
      //   locationTypeIds: filters.locationTypes.map(({ id }) => id),
      //   offset,
      //   outputChannel,
      // });

      const response = await algoliaSearch(term, outputChannel);
      dispatch(fetchSearchDataSuccess(response as ProductsSearchResponseData, offset, filters));
    } catch (e) {
      console.log(e);
      dispatch(fetchSearchDataError({ message: e.message }));
    }
  };
};

export const fetchSearchDataBegin = (term: string) => ({
  type: FetchSearchDataBegin,
  payload: term,
});

export const fetchSearchDataSuccess = (
  responseData: ProductsSearchResponseData,
  offset: number,
  filters: SearchFilterData
) => ({
  type: FetchSearchDataSuccess,
  payload: { ...responseData, offset, filters },
});

export const fetchSearchDataError = (error) => ({
  type: FetchSearchDataError,
  payload: { error },
});

export const fetchTopSearchedProducts = (outputChannel: string) => {
  return async (dispatch) => {
    dispatch(fetchTopSearchedProductsBegin());

    try {
      const response = await makeRequest<{ productsSearch: ProductEntity[] }>(
        QUERY_TOP_SEARCHED_PRODUCTS,
        { outputChannel }
      );

      dispatch(fetchTopSearchedProductsSuccess(response.productsSearch));
    } catch (e) {
      console.log(e);
      dispatch(fetchTopSearchedProductsError({ message: e.message }));
    }
  };
};

export const fetchTopSearchedProductsBegin = () => ({
  type: FetchTopSearchedProductsBegin,
});

export const fetchTopSearchedProductsSuccess = (results) => ({
  type: FetchTopSearchedProductsSuccess,
  payload: results,
});

export const fetchTopSearchedProductsError = (error) => ({
  type: FetchTopSearchedProductsError,
  payload: { error },
});

export const fetchTopSearchedProductCategories = () => {
  return async (dispatch) => {
    dispatch(fetchTopSearchedProductCategoriesBegin());

    try {
      const response = await makeRequest<{ topSearchedProductCategories: ProductCategoryEntity[] }>(
        QUERY_TOP_SEARCHED_PRODUCT_CATEGORIES,
        {}
      );

      dispatch(fetchTopSearchedProductCategoriesSuccess(response.topSearchedProductCategories));
    } catch (e) {
      console.log(e);
      dispatch(fetchTopSearchedProductCategoriesError({ message: e.message }));
    }
  };
};

export const fetchTopSearchedProductCategoriesBegin = () => ({
  type: FetchTopSearchedProductCategoriesBegin,
});

export const fetchTopSearchedProductCategoriesSuccess = (results) => ({
  type: FetchTopSearchedProductCategoriesSuccess,
  payload: results,
});

export const fetchTopSearchedProductCategoriesError = (error) => ({
  type: FetchTopSearchedProductCategoriesError,
  payload: { error },
});

export const fetchSearchFilterData = () => {
  return async (dispatch) => {
    dispatch(fetchSearchFilterDataBegin());

    try {
      const response = await makeRequest<{
        productCategories: ProductCategoryEntity[];
        designers: DesignerEntity[];
        locationTypes: LocationTypeEntity[];
      }>(QUERY_SEARCH_FILTER_DATA, {});

      dispatch(
        fetchSearchFilterDataSuccess({
          productCategories: response.productCategories.map(({ slug, ...rest }) => ({
            value: slug,
            ...rest,
          })),
          designers: response.designers.map(({ slug, ...rest }) => ({ value: slug, ...rest })),
          locationTypes: response.locationTypes.map(({ slug, ...rest }) => ({
            value: slug,
            ...rest,
          })),
        })
      );
    } catch (e) {
      console.log(e);
      dispatch(fetchSearchFilterDataError({ message: e.message }));
    }
  };
};

export const fetchSearchFilterDataBegin = () => ({
  type: FetchSearchFilterDataBegin,
});

export const fetchSearchFilterDataSuccess = (searchFilterData) => ({
  type: FetchSearchFilterDataSuccess,
  payload: searchFilterData,
});

export const fetchSearchFilterDataError = (error) => ({
  type: FetchSearchFilterDataError,
  payload: { error },
});
